module.exports = __webpack_public_path__ + "static/img/logo.b31c0064.svg";